const BASE = {
	BASE_URL: '/',
	APP_NAME: 'Rumis Employment Application',
	APP_SHORT_NAME: 'RMK Application',
};

export type CONFIG_TYPE = typeof BASE & {
	SERVER: string;
	WSS: string;
	API_SERVER: string;
};

const SERVER = process.env.REACT_APP_SERVER || '';
const WSS = process.env.REACT_APP_WSS || '';

export const CONFIG: CONFIG_TYPE = {
	...BASE,
	SERVER,
	WSS,
	API_SERVER: SERVER + '/api',
};

window.CONFIG = CONFIG;
